import { Button, Pagination } from "antd";
import { formatarHoraChat } from "./chatFormat";
import {
  TAMANHO_PAGINA_LIBERACOES,
  paginaAjustadaLiberacao,
  recortarLiberacoes,
} from "./chatLiberacoesPaginacao";

export const ChatLiberacoesLista = ({
  itens,
  pagina,
  onPagina,
  rotulo,
  onAtivar,
  onDesativar,
}) => {
  const atual = paginaAjustadaLiberacao(itens.length, pagina);
  const visiveis = recortarLiberacoes(itens, atual);

  return (
    <>
      {visiveis.map((item) => (
        <div className="chat-liberacao-item" key={item.codigo}>
          <div>
            <p>{rotulo(item)}</p>
            <small>
              {item.concedidoPorNome} · {formatarHoraChat(item.dataCadastro)}
            </small>
          </div>
          {item.ativa ? (
            <Button size="small" onClick={() => onDesativar(item.codigo)}>
              Desativar
            </Button>
          ) : (
            <Button size="small" type="primary" onClick={() => onAtivar(item.codigo)}>
              Ativar
            </Button>
          )}
        </div>
      ))}
      {itens.length > TAMANHO_PAGINA_LIBERACOES ? (
        <div className="chat-liberacoes__paginacao">
          <Pagination
            size="small"
            current={atual}
            pageSize={TAMANHO_PAGINA_LIBERACOES}
            total={itens.length}
            showSizeChanger={false}
            showLessItems
            onChange={onPagina}
          />
        </div>
      ) : null}
    </>
  );
};
